const LitecoinCnt = {
  symbol: "LTC",
  name: "litecoin",
  meta: {
    title: "Buy litecoin | litecoin Sale litecoin prices and charts",
    description:
      "Bitcoin is known as digital gold and Light Coin is known as digital silver. Experience LightCoin (LTC) more securely and faster at Quinnick Market than anywhere else. Buy and sell LightQueen with one click.",
    keywords: "Litecoin, Buy litecoin, Sell litecoin, litecoin Price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه لایت کوین بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید لایت کوین کنید. قیمت لایت کوین در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول لایت کوین کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " برای لایت کوین ده‌ها کیف پول با نام‌های گوناگون وجود دارد و بنابراین اگر یک سرمایه‌گذار لایت کوین باشید، پیدا کردن کیف پول کار سختی برای شما نیست. در ادامه چند مورد از بهترین کیف پول‌های لایت کوین را معرفی کرده‌ایم: کیف پول‌های سخت‌افزاری Ledger و Trezor. کیف پول‌های موبایل Trust، Exodus، Coinomi، Jaxx. کیف پول دسکتاپ Litecoin-QT",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم لایت کوین نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن لایت کوین دارید، که می‌توانید لایت کوین را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا لایت کوین ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " لایت کوین برادر کوچک بیت کوین است. این ارز دیجیتال دقیقاً مانند بیت کوین یک ارز دیجیتال همتابه‌همتاست. با این حال، طراحی شده تا سریع‌تر از بیت کوین تراکنش‌ها را پردازش کند، از این رو واژه «لایت» برای آن به کار برده شده است. لایت کوین از بدو تأسیس خود با استقبال خوبی روبرو شده است و حالا جایگاه خود را در میان بزرگترین ارزهای دیجیتال جهان تثبیت کرده است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Litecoin",
      answer:
        "In coinnik Market trading platform, you can buy Litecoin with Shetab member bank card and the lowest fee. The price of Light Coin in Quinnic Market is determined by you",
      id: "toggler1",
    },
    {
      question: "What is the best Litecoin wallet?",
      answer: "Litecoin_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Litecoin at coinnik Market?",
      answer: "Keep_Litecoin_description",
      id: "toggler3",
    },
    {
      question: "Is Litecoin worth the investment?",
      answer: "Litecoin_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Litecoin",
        subTitle: "What is Litecoin",
        content: "Litecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Litecoin",
        content: "Litecoin_history_description",
        btnTitle: "Buy and sell Litecoin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Litecoin without intermediaries in coinnik Market",
        subTitle: "Buy Litecoin",
        content: "Buy_Litecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Litecoin",
        content: "Sell_Litecoin_description",
        btnTitle: "Buy and sell Litecoin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Litecoin analysis on the blog",
  informationTitle: "Litecoin market statistics and information",
};

export default LitecoinCnt;
